import { Component } from '@angular/core';
import { BackgroundDecorationComponent } from '../shared-components/background-decoration/background-decoration.component';

@Component({
  selector: 'app-no-cdr-required',
  templateUrl: './no-cdr-required.component.html',
  styleUrl: './no-cdr-required.component.scss',
  imports: [BackgroundDecorationComponent],
})
export class NoCdrRequiredComponent {}
